export const attachImageUrl = (slug: string) => {
  switch (slug) {
    case "shipping":
      return "/images/membership/redeemed-benefits-shipping.png";
    case "discounts":
      return "/images/membership/redeemed-benefits-discount.png";
    case "gift":
      return "/images/membership/redeemed-benefits-gifts.png";
    default:
      return "/images/membership/redeemed-benefits-shipping.png";
  }
};
